import { render, staticRenderFns } from "./SupportReviewEditor.vue?vue&type=template&id=37d5e5ae&scoped=true&"
import script from "./SupportReviewEditor.vue?vue&type=script&lang=js&"
export * from "./SupportReviewEditor.vue?vue&type=script&lang=js&"
import style0 from "./SupportReviewEditor.vue?vue&type=style&index=0&id=37d5e5ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d5e5ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VBtn,VCol,VProgressLinear,VRow,VSelect,VSpacer,VTextField,VTextarea})
